import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";

const WhatsAppFloat = () => {
  const { t } = useLang();
  const href = `https://wa.me/34622669378?text=${encodeURIComponent(t.wa.prefill)}`;

  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.wa.label}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] p-4 text-white shadow-xl shadow-black/25 transition-all duration-300 hover:bg-[#1fb857]"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" aria-hidden="true" />
      <MessageCircle size={24} className="relative" />
      <span className="relative max-w-0 overflow-hidden font-mono text-xs uppercase tracking-widest opacity-0 transition-all duration-500 group-hover:ml-3 group-hover:max-w-[10rem] group-hover:opacity-100">
        {t.wa.label}
      </span>
    </a>
  );
};

export default WhatsAppFloat;
